/**************************************************
 * Nombre:       Tarjeta_Prueguntas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {ArrowForward, ArrowUpward} from '@mui/icons-material'
import {useState} from "react";
import {theme} from "../../Tema";


const Tarjeta_Prueguntas = ({item}) => {
    const [open, setOpen] = useState(false);

    return (
        <Grid
            onClick={() => setOpen(!open)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: 'white',
                borderRadius: 6,
                p: 4,
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: theme.palette.secondary.main,
                }
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                {open ?
                  <ArrowUpward/>
                    :
                    <ArrowForward/>
                }
            </Grid>

            <Collapse in={open} sx={{width: '100%'}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                    <Typography>{item.descripcion}</Typography>
                </Grid>
            </Collapse>

        </Grid>
    )

}
export default Tarjeta_Prueguntas    